import { render, staticRenderFns } from "./ValidAccount2.vue?vue&type=template&id=6b311a74&scoped=true&"
import script from "./ValidAccount2.vue?vue&type=script&lang=js&"
export * from "./ValidAccount2.vue?vue&type=script&lang=js&"
import style0 from "./ValidAccount2.vue?vue&type=style&index=0&id=6b311a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b311a74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
